/*
 * @Description: 价目管理 新增、编辑弹出层
 * @Author: ma.cq
 * @Date: 2018-10-18 09:33:29
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-11-01 14:16:44
 */
<template>
  <el-dialog title="新增资金同步对账" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form class="form" :model="form" :rules="rules" ref="form" v-if="visible">
      <el-form-item label="交易日期" prop="lockStartTime">
        <el-date-picker
          v-model="form.lockStartTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <!-- <el-date-picker
          v-model="form.lockStartTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker> -->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// import { formatTime } from '../../../common/utils'

export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      form: {
        lockStartTime: []
      },
      forms: {
        lockStartTime: []
      },
      // forms: {
      //   lockStartTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      // },
      rules: {
        lockStartTime: [
          { required: true, message: '请输入时间' }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$emit('onform', this.form)
      this.$emit('update:show', false)
      this.form = this.forms
      this.$emit('update:show', false)
    },
    handleClose () {
      this.$emit('update:show', false)
      this.form = this.forms
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
    }
  }
}
</script>
<style lang="scss" scoped>
.form{
  margin: 0 auto;
  max-width: 500px;
}
.item-inline{
  display: inline-block;
}
.marLef10{
  margin-left: 10px;
}
.tip{
  color: #ccc;
  font-size: 12px;
}
.tag{
  margin: 10px 10px 0 0;
}
.timepicker{
  margin-right: 10px;
  width: 120px;
}
</style>
